// Main exports
export { DrawerProvider, useDrawer, drawerMessageBus } from './DrawerProvider'
export { Drawer, DrawerContainer } from './Drawer'
export { DrawerHeader } from './DrawerHeader'
export { DrawerFooter } from './DrawerFooter'
export { DrawerSkeleton } from './DrawerSkeleton'
export { DrawerBreadcrumbs } from './DrawerBreadcrumbs'

// Type exports
export type { DrawerConfig, DrawerMessage } from './DrawerProvider'

// Preset configurations
export const DRAWER_PRESETS = {
  form: {
    size: 'lg' as const,
    confirmClose: true,
    autoSave: true,
    collapsibleSections: true,
    closeOnOutsideClick: false,
  },
  details: {
    size: 'xl' as const,
    closeOnOutsideClick: false,
    lazyLoad: true,
  },
  quickAction: {
    size: 'sm' as const,
    closeOnOutsideClick: true,
  },
  wizard: {
    size: '80' as const,
    closeOnOutsideClick: false,
    showCloseButton: false,
  },
} as const